



































import Vue from "vue";
import ListTemplate from "@/components/templates/ListTemplate.vue";
import CharacterList from "@/components/organisms/CharacterList.vue";
import CharacterFolderList from "@/components/organisms/CharacterFolderList.vue";
import CharacterDetail from "@/components/organisms/CharacterDetail.vue";
import SpTab from "@/components/molecules/SpTab.vue";
import BackToList from "@/components/atoms/BackToList.vue";
import { callApi } from "@/lib/api";
import { Plan } from "@/lib/models";
// NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
// import { Dialog } from "@/lib/utils";
// import PremiumFeatureDialog, { PremiumFeatureDialogProps } from "@/components/ui/PremiumFeatureDialog.vue";
// import { downloadPublicImage } from "@/lib/s3";

export default Vue.extend({
  components: {
    ListTemplate,
    CharacterList,
    CharacterFolderList,
    CharacterDetail,
    BackToList,
    SpTab,
  },
  props: {
    novelId: String,
    characterId: String,
  },
  data() {
    return {
      characters: null,
      selected: null,
      charactersCount: null,
      folders: null,
      isShowFolderList: false,
      isFolderInsertMode: false,
      targetCharacter: null,
      characterFolder: null,
      selectedFolderId: null,
    };
  },
  async created() {
    const characters = await this.getCharacters();
    this.characters = characters.items;
    this.charactersCount = characters.items.length;
    const characterFolders = await this.getFolders();
    this.folders = characterFolders.items;
    this.load();
  },
  computed: {
    plan() {
      return this.$store.getters["userModule/plan"] as Plan;
    },
    isFree() {
      return this.plan === Plan.free;
    },
  },
  methods: {
    async getCharacters() {
      const { novelId } = this;
      const GetQuery = `
        query ListCharacters($input: ListCharacterInput!){
          characters(input: $input) {
            nextToken
            items {
              novelId
              characterId
              name
              image
              createdAt
              updatedAt
              detail {
                name
                value
              }
              additionalColumn {
                name
                label
                content
              }
            }
          }
        }`;
      const { characters } = await callApi(GetQuery, {
        input: {
          novelId,
        },
      });
      return characters;
    },
    async getFolders() {
      const { novelId } = this;
      const ListCharacterFolder = `
        query ListCharacterFolder ($novelId: ID!){
          characterFolders (novelId: $novelId){
            novelId
            items {
              characterFolderId
              name
              characterKeys
            }
          }
        }`;
      const { characterFolders } = await callApi(ListCharacterFolder, {
        novelId,
      });
      return characterFolders;
    },
    async selectFolder(characterFolderId) {
      const { novelId } = this;
      const query = `
        query ListFolderCharacter ($input: GetFolderCharactersInput!) {
          folderCharacters (input: $input) {
            items {
              novelId
              characterId
              name
              image
              createdAt
              updatedAt
              detail {
                name
                value
              }
              additionalColumn {
                name
                label
                content
              }
            }
          }
        }`;
      const { folderCharacters } = await callApi(query, {
        input: {
          novelId,
          characterFolderId,
        },
      });
      this.characters = folderCharacters.items;
      this.characterFolder = this.folders.find((folder) => folder.characterFolderId === characterFolderId);
      try {
        if (this.characterFolder) {
          this.characters.sort(
            (x, y) =>
              this.characterFolder.characterKeys.indexOf(x.characterId) -
              this.characterFolder.characterKeys.indexOf(y.characterId)
          );
        }
      } catch (error) {
        console.log(error);
      }
      this.isShowFolderList = false;
    },
    async showFolderList() {
      if (this.isFree) {
        this.showPremiumFeatureDialog();
        return;
      }

      const characters = await this.getCharacters();
      const characterFolders = await this.getFolders();

      this.characters = characters.items;
      this.charactersCount = characters.items.length;
      this.folders = characterFolders.items;
      this.isShowFolderList = true;
    },
    setFolder(el) {
      if (this.isFree) {
        this.showPremiumFeatureDialog();
        return;
      }

      this.targetCharacter = el.character;
      this.selectedFolderId = el.characterFolder ? el.characterFolder.characterFolderId : null;
      this.isFolderInsertMode = true;
      this.isShowFolderList = true;
    },
    async finishFolderSelect() {
      await this.selectFolder(this.selectedFolderId);

      this.targetCharacter = null;
      this.isFolderInsertMode = false;
      this.isShowFolderList = false;
    },
    cancelInsertFolder() {
      this.isFolderInsertMode = false;
      this.isShowFolderList = false;
    },
    deleteHandle(characterId) {
      const { novelId } = this;
      const index = this.characters.findIndex((item) => item.characterId === characterId);
      this.$delete(this.characters, index);
      this.$router.push({
        name: "characters",
        params: { novelId },
      });
    },
    load() {
      const list = this.characters;
      if (!list) {
        this.selected = null;
        return;
      }
      if (this.characterId) {
        this.selected = list.find((c) => c.characterId === this.characterId);
        return;
      }
      if (list.length) {
        this.selected = list[0];
      }
    },
    async showPremiumFeatureDialog() {
      // NOTE: 機能紹介GIFを修正するため一時的にコメントアウト
      // const premiumFeatureDialog = new Dialog(PremiumFeatureDialog);
      // const data: PremiumFeatureDialogProps = {
      //   title: "フォルダ機能はプレミアム機能です",
      //   text: "Nolaプレミアムにご登録いただくと、お好きな名前で資料を管理できる『フォルダ管理機能』をご利用いただけます。”〇〇高校”などの組織ごとの管理や、”味方”、”敵陣”などキャラクターの役割ごとの資料管理ができますので、お手すきの際にぜひご活用いただだけたら幸いです。",
      //   image: (await downloadPublicImage("shared/images/gif/character_folder.gif")) as string,
      // };
      // premiumFeatureDialog.show(data);

      this.$router.push({ name: "subscriptionAnnounce", query: { from: "characterFolder" } });
    },
  },
  watch: {
    $route: "load",
  },
});
